module.exports = __webpack_public_path__ + "static/media/glance.cacd5a31.svg";